// translations/es.ts
import { TranslationKeys } from '../index';

export const es: TranslationKeys = {
  header: {
    tutorialButton: "Tutoriales",
    currentLanguage: "Actual"
  },
  hero: {
    title: "¡Juega Sudoku Vs Ahora!",
    description: "¡Prepárate para un desafío de Sudoku como ningún otro! Disfruta de la práctica en solitario o enfréntate a tus amigos — ¡descarga ahora y experimenta la emoción!",
    howToPlay: "Cómo Jugar",
    discordButton: "Únete a nuestro Discord",
    googlePlay: {
      topText: "Consíguelo en",
      bottomText: "Google Play"
    },
    appStore: {
      topText: "Descargar en la",
      bottomText: "App Store"
    },
    botButtonShow: "¿Necesitas Ayuda? ¡Pregunta a Nuestro Bot!",
    botButtonHide: "Ocultar Asistente"
  },
  footer: {
    followUs: "SÍGUENOS EN",
    handle: "@SUDOKU.VS",
    copyright: "© 2024 Sudoku VS. Todos los derechos reservados."
  },
  beginnersGuide: {
    modalTitle: "GUÍA PARA PRINCIPIANTES",
    originsTab: "ORÍGENES DEL SUDOKU",
    basicsTab: "CONCEPTOS BÁSICOS DEL SUDOKU",
    rulesTab: "REGLAS DE JUEGO VS",
    origins: {
      bulletOne: "Inspirado en los cuadrados latinos; publicado por primera vez en 1979 por Howard Garns.",
      bulletTwo: "Se hizo popular en Japón en los años 80, rebautizado como 'Sudoku'. Ganó fama mundial en los 2000.",
      bulletThree: "Cuadrícula de 9x9 con nueve subcuadrículas de 3x3; rellena con números del 1 al 9 sin repetir en filas, columnas o subcuadrículas.",
      bulletFour: "Amado por millones, con muchas variaciones y nuevos desafíos.",
      gridSize: {
        four: "4 X 4",
        six: "6 X 6",
        nine: "9 X 9",
      }
    },
    basics: {
      fillMissing: "¡Rellena el número que falta!",
      correct: "¡CORRECTO!",
      incorrect: "INCORRECTO",
      instructions: "Completa el rompecabezas de 3X3 ingresando el número correcto en el espacio resaltado. Cada fila, columna y caja debe contener cada número exactamente una vez. Selecciona el número correcto. ¡Elige sabiamente!",
      feedbackCorrect: "¡RESOLVISTE TU PRIMERA CAJA!",
      feedbackIncorrect: "¡INTÉNTALO DE NUEVO!",
      basicsStep2: {
        instructions: "Completa el rompecabezas de 4X4 seleccionando el número correcto para el espacio resaltado. Cada fila, columna y caja debe contener cada número exactamente una vez. Selecciona el número correcto. ¡Elige sabiamente!",
        feedbackCorrect: "¡ESTÁS ENRACHADO!"
      },
      basicsStep3: {
        instructions: "Completa el rompecabezas de 4X4 seleccionando el número correcto para el espacio resaltado. Cada fila, columna y caja debe contener cada número exactamente una vez. Selecciona el número correcto. ¡Elige sabiamente!",
        feedbackCorrect: "¡SOLUCIÓN PERFECTA!",
        feedbackIncorrect: "INCORRECTO - ¡INTÉNTALO DE NUEVO!"
      },
      congratulations: {
        title: "¡Felicidades!",
        subtitle: "¡Has completado con éxito el tutorial de conceptos básicos de Sudoku! Tu dedicación y esfuerzo han dado sus frutos, y ahora estás equipado con las habilidades esenciales para abordar los rompecabezas de Sudoku con confianza.",
        nextStepsTitle: "Próximos Pasos",
        nextStepsText: "¡Ahora es el momento de poner a prueba tus habilidades! Descarga el juego de Sudoku hoy y sumérgete en una variedad de rompecabezas. Ya sea que prefieras una partida rápida en solitario o quieras participar en una competencia amistosa, puedes elegir jugar en modo individual o en modo vs contra un oponente.",
        ctaHeader: "¿Te apetece una partida?",
        ctaHighlight: "¡Descárgalo Ahora!",
        rulesTitle: "Domina las Reglas del Juego",
        rulesText: "Antes de que te sumerjas, asegúrate de revisar las reglas del juego de Sudoku VS. Comprender las reglas y el sistema de puntos puede darte una ventaja al jugar contra oponentes. ¡Este conocimiento mejorará tu experiencia y te ayudará a elaborar estrategias de manera efectiva!"
      }
    },
    gameRules: {
      notification: {
        important: "Importante: ",
        text: "¡Habilita las notificaciones para una mejor experiencia!"
      },
      rulesHeader: "Reglas",
      rulesList: {
        rule1_pre: "Acepta o crea una invitación a una ",
        rule1_strong: "partida amistosa o aleatoria.",
        rule1_post: "",
        rule2_pre: "El jugador ",
        rule2_strong: "se selecciona al azar para empezar.",
        rule3: "Los jugadores se turnan hasta que el tablero esté completo.",
        rule4_pre1: "Cada ",
        rule4_strong1: "turno dura 60 segundos,",
        rule4_pre2: " con un límite de ",
        rule4_strong2: "5 números por turno.",
        rule5_pre: "Solo se permite ",
        rule5_strong: "1 pista",
        rule5_post: " por turno.",
        rule6_pre: "El jugador con ",
        rule6_strong: "la puntuación más alta gana",
        rule6_post: " la partida.",
        rule7_pre: "En caso de ",
        rule7_strong_pre: "empate",
        rule7_pre2: ", el jugador con más entradas ",
        rule7_strong_post: "gana",
        rule7_post: " la partida.",
        rule8: "Si no terminas tu turno en 24 horas, pierdes automáticamente la partida."
      },
      rulesWarning: "Juega tu turno en 24 horas o perderás la partida automáticamente",
      gameControls: {
        header: "Controles del Juego",
        list: {
          control1_pre: "Usa ",
          control1_strong: "la bandera de Rendición",
          control1_post: " para abandonar la partida.",
          control2_pre: "Usa ",
          control2_strong: "el Borrador",
          control2_post: " para corregir un error.",
          control3_pre: "Usa ",
          control3_strong: "Finalizar Turno",
          control3_post: " si has completado todas tus entradas antes de que se acabe el tiempo."
        }
      },
      scoring: {
        header: "Puntuación",
        list: {
          score1_pre1: "Gana ",
          score1_strong1: "1 punto",
          score1_pre2: " por cada número ",
          score1_span: "correcto.",
          score1_post: "",
          score2_pre1: "Pierde ",
          score2_strong1: "1 punto",
          score2_pre2: " por cada número ",
          score2_span: "incorrecto.",
          score2_post: "",
          score3_pre1: "Gana ",
          score3_strong1: "5 puntos",
          score3_pre2: " por cada fila, columna y caja ",
          score3_span: "resuelta.",
          score3_post: ""
        }
      }
    },
    controller: {
      previous: "Anterior",
      of: " de ",
      close: "Cerrar",
      next: "Siguiente",
      gameRules: "Reglas del Juego",
    },
  },
  tutorials: {
    modalTitle: "Tutoriales",
    tabs: {
      introduction: "Introducción",
      gettingStarted: "Primeros Pasos",
      vsFriends: "Contra Amigos",
      howToPlay: "Cómo Jugar",
    },
    messages: {
      loading: "Cargando tutoriales...",
      error: "Error al cargar los tutoriales:",
      fallback: "Usando datos de respaldo...",
      empty: "No hay tutoriales disponibles para esta sección.",
    },
  },
  copywright: {
    text: "Copyright © 2025 Software Architects Ltd. Todos los derechos reservados."
  },
  cookieConsent: {
    title: "Gestionar Preferencias",
    description: "Usamos cookies para mejorar tu experiencia en Sudoku VS, analizar nuestro tráfico y ofrecer anuncios personalizados.",
    acceptAll: "Aceptar Todas las Cookies",
    confirmChoices: "Confirmar Opciones",
    performance: {
      title: "Cookies de Rendimiento",
      description: "Nos permiten recopilar datos para mejorar nuestro juego y servicios a través de análisis de uso."
    },
    advertising: {
      title: "Publicidad",
      adStorage: "Permite el almacenamiento de datos publicitarios en tu dispositivo.",
      adMeasurement: "Permite la recopilación de datos para la medición de la publicidad.",
      adPersonalization: "Nos permite mostrarte anuncios personalizados basados en tus intereses."
    },
    landing: {
        title: "Aviso de Cookies",
        description: "Usamos cookies para mejorar tu experiencia en Sudoku VS, analizar nuestro tráfico y ofrecer anuncios personalizados. Puedes configurar qué cookies deseas permitir antes de continuar.",
        acceptAll: "Aceptar todas las Cookies",
        customizeSettings: "Personalizar Ajustes",
        fineprint: "Al hacer clic en \"aceptar todas las cookies\", aceptas que<br />Sudoku VS pueda almacenar cookies en tu dispositivo"
    }
  },

    privacyPolicy: {
    modalTitle: "Política de Privacidad",
    sections: {
      introduction: {
        title: "1. Introducción",
        p1: "Bienvenido a Sudoku VS. Estamos comprometidos a proteger su privacidad y garantizar que tenga una experiencia positiva en nuestro sitio web. Esta Política de Privacidad explica cómo recopilamos, utilizamos y protegemos su información cuando utiliza nuestra plataforma de juegos de Sudoku.",
        p2: "Al utilizar Sudoku VS, usted acepta la recopilación y el uso de la información de acuerdo con esta política."
      },
      informationWeCollect: {
        title: "2. Información que Recopilamos",
        p1: "Recopilamos diferentes tipos de información para proporcionar y mejorar nuestros servicios:",
        list: {
          usageData: "Datos de Uso: Recopilamos automáticamente información sobre cómo interactúa con nuestro juego, incluyendo estadísticas de juego, tiempos de finalización de rompecabezas, niveles de dificultad jugados y preferencias de juego.",
          deviceInfo: "Información del Dispositivo: Podemos recopilar información sobre el dispositivo que utiliza para acceder a Sudoku VS, incluido el tipo de dispositivo, tipo de navegador, dirección IP y sistema operativo.",
          cookies: "Cookies y Datos de Seguimiento: Utilizamos cookies y tecnologías de seguimiento similares para mejorar su experiencia y recopilar datos analíticos."
        }
      },
      howWeUseInfo: {
        title: "3. Cómo Utilizamos su Información",
        p1: "Utilizamos la información recopilada para los siguientes propósitos:",
        list: {
          gameImprovement: "Mejora del Juego: Para analizar patrones de juego y mejorar nuestros rompecabezas de Sudoku, algoritmos de dificultad y la experiencia general del usuario.",
          performanceAnalytics: "Análisis de Rendimiento: Para monitorear y analizar tendencias de uso, medir la efectividad de nuestros servicios e identificar áreas de mejora.",
          personalization: "Personalización: Para proporcionarle recomendaciones de juego personalizadas y contenido adaptado basado en sus preferencias de juego.",
          technicalSupport: "Soporte Técnico: Para solucionar problemas, corregir errores y garantizar el funcionamiento sin problemas de nuestra plataforma."
        }
      },
      cookies: {
        title: "4. Cookies y Tecnologías de Seguimiento",
        p1: "Sudoku VS utiliza cookies para mejorar su experiencia. Tiene la opción de gestionar sus preferencias de cookies:",
        performanceCookies: {
          title: "Cookies de Rendimiento:",
          description: "Estas cookies nos permiten recopilar datos para mejorar nuestro juego y servicios a través de análisis de uso. Nos ayudan a comprender cómo los jugadores interactúan con nuestros rompecabezas, qué funciones son más populares y dónde podemos hacer mejoras. Estos datos son esenciales para mejorar la jugabilidad y crear mejores experiencias de Sudoku."
        },
        advertisingCookies: {
          title: "Cookies Publicitarias:",
          list: [
            "Permiten el almacenamiento de datos publicitarios en su dispositivo",
            "Habilitan la recopilación de datos para la medición y efectividad de la publicidad",
            "Nos permiten mostrarle anuncios personalizados basados en sus intereses y comportamiento de juego"
          ]
        },
        p2: "Puede controlar sus preferencias de cookies a través del banner de consentimiento de cookies que aparece cuando visita por primera vez nuestro sitio web. Puede cambiar su configuración en cualquier momento a través de la configuración de su navegador, aunque deshabilitar ciertas cookies puede afectar la funcionalidad del sitio web."
      },
      thirdParty: {
        title: "5. Servicios de Terceros",
        p1: "Sudoku VS se integra con los siguientes servicios de terceros:",
        gemini: {
          title: "Asistente de IA Google Gemini:",
          description: "Nuestro bot de ayuda funciona con Google Gemini con una base de conocimiento integrada para ayudarle con preguntas relacionadas con el juego, proporcionar consejos de Sudoku y ayudar a solucionar problemas. Cuando interactúa con el bot, sus consultas pueden ser procesadas por los sistemas de Google. Consulte la Política de Privacidad de Google para obtener información sobre cómo manejan los datos."
        },
        youtube: {
          title: "Videos Incrustados de YouTube:",
          description: "Utilizamos superposiciones de video de YouTube para proporcionar contenido tutorial y guías de juego directamente dentro de nuestro sitio web. Cuando interactúa con estos videos, YouTube puede recopilar datos de acuerdo con su política de privacidad. Puede ver videos sin salir de Sudoku VS, pero los mecanismos de seguimiento de YouTube aún pueden aplicarse."
        },
        advertising: {
          title: "Socios Publicitarios:",
          description: "Trabajamos con socios publicitarios de terceros para mostrar anuncios en nuestra plataforma. Estos socios pueden utilizar cookies y tecnologías similares para recopilar información sobre su actividad de navegación con fines de publicidad personalizada."
        }
      },
      dataSecurity: {
        title: "6. Seguridad de Datos",
        p1: "Tomamos en serio la seguridad de sus datos e implementamos medidas técnicas y organizativas apropiadas para proteger su información contra el acceso, alteración, divulgación o destrucción no autorizados. Sin embargo, tenga en cuenta que ningún método de transmisión por Internet o almacenamiento electrónico es 100% seguro.",
        p2: "Nuestro sitio web utiliza protocolos de seguridad estándar de la industria y está verificado por el sello de seguridad de GoDaddy para garantizar una experiencia de navegación segura."
      },
      privacyRights: {
        title: "7. Sus Derechos de Privacidad",
        p1: "Tiene ciertos derechos con respecto a su información personal:",
        list: {
          access: "Acceso: Puede solicitar información sobre los datos que tenemos sobre usted",
          correction: "Corrección: Puede solicitar la corrección de información inexacta",
          deletion: "Eliminación: Puede solicitar la eliminación de sus datos, sujeto a obligaciones legales",
          optOut: "Exclusión: Puede optar por no recibir publicidad personalizada a través de sus preferencias de cookies",
          portability: "Portabilidad de Datos: Puede solicitar una copia de sus datos en un formato portátil"
        }
      },
      childrenPrivacy: {
        title: "8. Privacidad Infantil",
        p1: "Sudoku VS está diseñado para audiencias generales. No recopilamos conscientemente información personal de niños menores de 13 años. Si es padre o tutor y cree que su hijo nos ha proporcionado información personal, contáctenos para que podamos tomar las medidas apropiadas."
      },
      changes: {
        title: "9. Cambios en esta Política de Privacidad",
        p1: "Podemos actualizar esta Política de Privacidad de vez en cuando para reflejar cambios en nuestras prácticas o por razones legales, operativas o regulatorias. Le notificaremos cualquier cambio material publicando la nueva Política de Privacidad en esta página y actualizando la fecha de \"Última actualización\" a continuación.",
        p2: "Le recomendamos que revise esta Política de Privacidad periódicamente para mantenerse informado sobre cómo protegemos su información."
      },
      contact: {
        title: "10. Contáctenos",
        p1: "Si tiene alguna pregunta, inquietud o solicitud con respecto a esta Política de Privacidad o nuestras prácticas de datos, contáctenos:",
        email: "Correo electrónico: privacy@sudoku.vs",
        website: "Sitio web: www.sudoku.vs",
        p2: "Responderemos a su consulta lo antes posible."
      }
    },
    footer: {
      lastUpdated: "Última actualización: 10 de octubre de 2025",
      effectiveDate: "Fecha de efectividad: 10 de octubre de 2025"
    }
  },
languages: {
    en: "English",
    es: "Español", 
    fr: "Français",
    hi: "हिन्दी",
    bn: "বাংলা",
    pt: "Português",
    it: "Italiano",
    ru: "Русский",
    ja: "日本語",
    ko: "한국어"
},
};